import React from "react";
import { Download, Expand } from "lucide-react";

interface LineChartActionsProps {
  onDownload: () => void;
  onExpand: () => void;
}

export const LineChartActions: React.FC<LineChartActionsProps> = ({
  onDownload,
  onExpand,
}) => {
  return (
    <div className="diagram-buttons absolute right-2 top-2 flex gap-1">
      <button
        onClick={onDownload}
        className="inline-flex h-8 w-8 items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none hover:bg-accent hover:text-accent-foreground rounded-sm"
        aria-label="Download as PNG"
        title="Download as PNG"
      >
        <Download className="h-4 w-4" />
      </button>
      <button
        onClick={onExpand}
        className="inline-flex h-8 w-8 items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none hover:bg-accent hover:text-accent-foreground rounded-sm"
        aria-label="Expand"
        title="Expand"
      >
        <Expand className="h-4 w-4" />
      </button>
    </div>
  );
};
